<template>
  <app-layout class="modules-template alliances-template">
    <!-- <div class="loader" v-if="isLoadingTracks">
      <Spin size="large" fix></Spin>
    </div> -->
    <div v-if="!isLoadingTracks">
      <EmptyPlaceholder :payload="sortedTracks"/>
      <Row type="flex" justify="center">
        <Col
          v-show="selectedTrackModules"
          :span="24"
          v-for="(item,k) in sortedTracks"
          :key="k"
          style="padding:10px;"
          :style="{paddingTop: (k !== 0)? '0px' : '10px'}"
        >
          <Card :style="{borderRadius: '0', borderTop: '1px solid #F2F2F2',
           boxShadow: item.id === previousModuleId ? '0px 0px 5px ' + categoryColor(isVisited(item.id)) : '',
           border: item.id === previousModuleId ? '1px solid '+ categoryColor(isVisited(item.id)) : ''}" :padding="0">
            <div
              :style="{backgroundImage: 'url('+item.thumbnail_photo[0].large+')'}"
              style="background-attachment: local;background-repeat: no-repeat;background-position: 50%;background-size: 100% auto;overflow:hidden"
            >
              <div class="lp pointer" @click="redirect(item.id, item.title, item)">
                <span
                  :style="{color: categoryColor(isVisited(item.id), isModuleFinished(item.id))}"
                  style="display: flex; align-items: center; position:absolute;top:10px;right:10px;font-size:10px"
                >
                  <div v-if="moduleProgress(item.id) > 0" style="color: white; margin-right: 5px; font-size: 12px;">
                    {{ moduleProgress(item.id) }}%
                  </div>
                  <i v-if="!isModuleFinished(item.id)" class="fa fa-circle" style="width: 14px; height: 16px"/>
                  <Icon v-else type="checkmark-circled" style="top: -1.2px; position: relative;"></Icon>
                </span>
                <h2 class="truncate" style="padding-top:20px;line-height: 25px;">{{item.title}}</h2>
                <p class="truncate" style="padding:5px 0 0;line-height: 15px;">{{item.description}}</p>
                <Row type="flex" v-show="false">
                  <i-col :span="6">
                    <div
                      class
                      style="display:flex;justify-content:center;overflow:hidden;width:60px;height:60px;background:#f2f2f2;border-radius:5px"
                    >
                      <img
                        :src="getDisplayImage(item)"
                        width="auto"
                        height="100%"
                        style="display:block;margin:0 auto;"
                      >
                    </div>
                    <!-- <Avatar shape="square" style="width:60px;height:60px" :src="item.thumbnail_photo[0].medium"></Avatar> -->
                  </i-col>
                  <i-col :span="18">
                    <p class="truncate" style="line-height:60px">
                      <b>{{item.title}}</b>
                    </p>
                  </i-col>
                </Row>
              </div>
            </div>
            <div class="track-progress-wrapper">
              <div class="track-progress" :style="{ width: `${moduleProgress(item.id)}%`, background: categoryColor(isVisited(item.id)) }"/>
            </div>
          </Card>
        </Col>
      </Row>
      <p align="center">
        <span @click="redirectParentLibrary()">
          <Avatar class="action-back pointer" :src="require('@/assets/back.png')" />
        </span>
      </p>
    </div>
  </app-layout>
</template>

<script>
import { mapGetters } from "vuex";
import Utils from "@/utils.js";
import VueCookie from "vue-cookie";
import EmptyPlaceholder from '@/components/EmptyPlaceholder';

export default {
  name: "TrackComponent",
  components: {
    EmptyPlaceholder
  },
  data() {
    return {
      keyword: null,
      orderList: null,
      visited:
        JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`
          )
        ) || [],
      catColors: {
        cope: {
          visited: "#1E89A7",
          new: "#38feff"
        },
        thrive: {
          visited: "#d0862a",
          new: "#facf11"
        },
        nourish: {
          visited: "#4b7315",
          new: "#93df1b"
        },
        heal: {
          visited: "#4E1C9B",
          new: "#c695fe"
        }
      },
      previousModuleId: JSON.parse(
        VueCookie.get(
          `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PREVIOUS_MODULE`
        )
      ) || null
    };
  },
  async mounted() {
    this.clear();

    console.log(">>>>>>>>>")

    await this.$store.dispatch("points/getCurrentUserTrackPoints", {
        journalId: this.userInfo.journal_id,
        trackId: this.$route.params.trackId
      });
  },
  beforeRouteEnter(to, from, next) {
    VueCookie.set(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PREVIOUS_MODULE`,
        JSON.stringify((from.params.moduleId) ? from.params.moduleId : null))
    next();
  },
  beforeRouteLeave(to, from, next){
    VueCookie.set(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PREVIOUS_MODULE`,
        JSON.stringify(null))
    next();
  },
  computed: {
    ...mapGetters("library", ["selectedTrackModules", "isLoadingLibrary"]),
    ...mapGetters("points", ["userTrackResiliency"]),
    userInfo: {
      get() {
        return this.$store.state.user.info;
      }
    },
    alliances: {
      get() {
        return this.$store.state.alliance.alliances;
      }
    },
    isLoadingTracks() {
      return this.isLoadingLibrary;
    },
    sortedTracks() {
      let origOrder = this.$route.query.careplan_ids.split(",");
      let res = [];

      origOrder.forEach(element => {
        for (let x = 0; x < this.selectedTrackModules.length; x++) {
          if (this.selectedTrackModules[x] && element === this.selectedTrackModules[x].id) {
            res.push(this.selectedTrackModules[x]);
            break;
          }
        }
      });

      return res;
    }
  },
  methods: {
    moduleProgress(moduleId) {
      if (!this.userTrackResiliency[moduleId]) return 0
      let maxPoints = this.userTrackResiliency[moduleId].module.max_points
      let currentPoints = this.userTrackResiliency[moduleId].points[this.$route.query.category]
      let progress = ((currentPoints/maxPoints)*100).toFixed(0)
      return progress > 100 ? 100 : progress
    },
    redirectParentLibrary() {
      let parentLibrary = JSON.parse(
        VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_LIBRARY`)
      );
      this.$router.replace(parentLibrary)
    },
    isModuleFinished(moduleId){
      var finishedModulesList = VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}FINISHED_MODULES`) || [];
      return finishedModulesList.includes(moduleId)
    },
    categoryColor(isVisited, isModuleFinished) {
      switch (this.$route.query.category) {
        case "Cope":
          if (isModuleFinished) return this.catColors.cope.new;
          else if (isVisited) return this.catColors.cope.visited;
          else return this.catColors.cope.new;
          break;
        case "Thrive":
          if (isModuleFinished) return this.catColors.thrive.new;
          else if (isVisited) return this.catColors.thrive.visited;
          else return this.catColors.thrive.new;
          break;
        case "Nourish":
          if (isModuleFinished) return this.catColors.nourish.new;
          else if (isVisited) return this.catColors.nourish.visited;
          else return this.catColors.nourish.new;
          break;
        case "Heal":
          if (isModuleFinished) return this.catColors.heal.new;
          else if (isVisited) return this.catColors.heal.visited;
          else return this.catColors.heal.new;
          break;
      }
    },
    getDisplayImage(v) {
      return Utils.getDisplayImage("group", v, "medium");
    },
    clear() {
      this.keyword = null;
      this.$store.dispatch(
        "library/getTrackModules",
        this.$route.query.careplan_ids
      );
    },
    search(v) {
      this.$store.dispatch("alliance/getAlliances", { keyword: v });
    },
    isVisited(i) {
      let x = this.visited.findIndex(v => {
        return v === i;
      });
      if (x >= 0) return true;
      return false;
    },
    setVisitedItem(i) {
      this.visited =
        JSON.parse(
          VueCookie.get(
            `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`
          )
        ) || [];
      let idx = this.visited.findIndex(v => {
        return v === i;
      });

      if (this.visited.length <= 0) {
        this.visited.push(i);
      } else if (this.visited.length > 0 && idx == -1) {
        this.visited.push(i);
      }

      VueCookie.set(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`,
        JSON.stringify(this.visited)
      );
    },
    redirect(moduleId, title, item) {
      this.$store.dispatch('statistics/postStats', {stat_type: 'activity_action', stat_id: item.id, link_tag: `View Discover Item : ${item.title}`});

      console.log(this.$route.fullPath);
      this.setVisitedItem(item.id);
      VueCookie.delete(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`
      );
      VueCookie.delete(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`
      );
      VueCookie.delete(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_TRACK`
      );
      VueCookie.set(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}PARENT_TRACK`,
        JSON.stringify(this.$route.fullPath)
      );
      VueCookie.set(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_ELEMENTS`,
        JSON.stringify(item.elements ? item.elements.join() : "")
      );
      VueCookie.set(
        `${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}CURRENT_MODULE_DOCUMENTS`,
        JSON.stringify(item.documents ? item.documents.join() : "")
      );
      this.$store.commit("setPageTitle", title);

      this.$store.commit("points/setVisited", {
        type: "track",
        id: item.id
      })

      let engageCourse = JSON.parse(VueCookie.get(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}ENGAGE_COURSE`));
      this.$store.dispatch("points/setUserActionPoints", {
        action: "open_course",
        user_story_id: engageCourse.userStory,
        track_id: engageCourse.course,
        module_id: engageCourse.article,
        category: engageCourse.category
      }, {root: 1})

      this.$router.push(
        `/${
          this.$route.params.brandSlug
        }/module/${moduleId}?tab=course&title=${title}&track_id=${
          this.$route.params.trackId
        }&careplan_ids=${this.$route.query.careplan_ids}
        &category=${this.$route.query.category}`
      );
    }
  }
};
</script>

<style scoped>
.track-progress-wrapper {
  width: 100%;
  height: 10px;
  margin-top: 2px;
  background: #adadad;
}

.track-progress-wrapper > .track-progress {
  height: 100%;
  transition: width .8s;
}

.bordered-module {
  border-style: dashed;
}
.modules-template .ivu-card {
  overflow: hidden;
}
.modules-template .ivu-card .ivu-card-body .lp {
  padding: 20px;
  line-height: 14px;
  background: #00000052;
}
.modules-template .ivu-card .ivu-card-body .lp h2 {
  color: #fff;
}
.modules-template .ivu-card .ivu-card-body .lp p {
  color: #f2f2f2;
}
.lp > b {
  word-break: break-all;
  text-align: left;
}
.loader {
  background: #ddd;
  min-height: 80vh;
}
.action-back {
  background: #fff;
}
</style>

